import {InfoCardDataType} from "../../interfaces/infoCard/InfoCard.type";
import {generateStyleClasses, getGeneralImage, styleHelper} from "../../helpers/commonFunctions";
import {useCallback} from "react";
import {StyleDataType} from "../../interfaces/headerGroup/HeaderGroup.type";
import styles from "./InfoCard.module.css";
import useAppStore from "../../store/AppStore";

const InfoCard = ({items}: {items: InfoCardDataType[]}) => {
    const item = items[0];
    const {isDeviceMobile} = useAppStore();
    const textSplitter = useCallback(
        (text: string,textColor: string,style: StyleDataType,startIcon: string,endIcon: string) => {
            if (!text) return null;
            let textSplit = text?.split("\n");
            return (
                <>
                    {textSplit.map((item: string, idx: number) => {
                        return (
                            <div key={idx} className={`vas-d-flex vas-flex-row vas-align-items-center`}>
                                {idx == 0 && startIcon && <img
                                    className={`vas vas-d-flex ${styles.padded_icon}`}
                                    src={getGeneralImage(startIcon)}
                                    alt="header_icon"
                                    height={32}
                                    width={32}
                                />}
                                <p
                                    className={`vas-m-0 ${style.bold ? "vas-fw-bold" : ""} ${
                                        style?.size === "xlarge"
                                            ? "vas-fs-4"
                                            : "vas-fs-6"
                                    }`}
                                    key={idx}
                                    style={styleHelper({ color: textColor })}>
                                    {item}
                                </p>
                                {idx == textSplit.length - 1 && endIcon && <img
                                    className="vas vas-mx-1 vas-d-flex"
                                    src={getGeneralImage(endIcon)}
                                    alt="header_icon"
                                    height={32}
                                    width={32}
                                />}
                            </div>
                        );
                    })}
                </>
            );
        },
        [item?.style, item?.textColor]
    );


    return (
        <div
            className={`${isDeviceMobile ? 'vas-mb-3 vas-mx-3' : 'vas-w-100 vas-border'} ${styles.shadowed_box} vas-border-radius vas-d-flex vas-justify-content-between vas-align-items-center vas-align-item vas-d-flex vas-px-3 vas-py-2`}
            style={styleHelper({
                borderColor: `${item.cardStyle.backgroundColor}`,
                backgroundColor: item.cardStyle.backgroundColor
            })}>
            <div className={generateStyleClasses(item.style)}>{textSplitter(item.text, item.textColor, item.style, item?.startIcon, item?.endIcon)}
            </div>
        </div>
    )
}

export default InfoCard;